import { Guid, RecursivePartial } from '@models/base';
import { BaseTaskAction, TaskActionType } from './_base-task-action';

export class TaskActionSubtaskRemove extends BaseTaskAction {
    type: TaskActionType.SubtaskRemove = TaskActionType.SubtaskRemove;
    taskId!: Guid;
    serial!: number;
    subj?: string;
    shortId?: string;
    projectId?: Guid;

    constructor(json?: RecursivePartial<TaskActionSubtaskRemove>) {
        super(json);
        this.parseTaskActionSubtaskRemove(json || {});
    }

    parse(json: RecursivePartial<TaskActionSubtaskRemove>): TaskActionSubtaskRemove {
        super.parse(json);
        this.parseTaskActionSubtaskRemove(json);
        return this;
    }

    private parseTaskActionSubtaskRemove(json: RecursivePartial<TaskActionSubtaskRemove>): void {
        TaskActionSubtaskRemove.assignFields<TaskActionSubtaskRemove>(this, json, ['taskId', 'serial', 'subj', 'shortId', 'projectId']);
    }
}
